import { render } from "./App.vue?vue&type=template&id=ecc8a3ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ecc8a3ba&lang=scss"

import exportComponent from "/codebuild/output/src2038848539/src/admin-wallet-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__